/*
 * @Author: 刑天
 * @Date: 2022-05-13 11:21:28
 * @LastEditTime: 2024-01-11 16:49:36
 * @Description: 战神
 */
import dayjs from 'dayjs';
import * as activitySetting from '../services/activitySetting';
import { getWeek } from '@/utils/date';

function selectStoreTreeListFun(storeTreeList) {
  let allStores = [];
  const getData = (list) => {
    for (let v of list) {
      if (v.children && Array.isArray(v.children)) {
        getData(v.children);
      } else {
        allStores.push(v);
      }
    }
  };

  getData(storeTreeList);
  return allStores;
}

//先按照日期排序，然后按照门店storeNo排序，然后按照场次排序
function sortFun(a, b) {
  const schedulingDateA = new Date(a.schedulingDate).getTime();
  const schedulingDateB = new Date(b.schedulingDate).getTime();
  if (schedulingDateA === schedulingDateB) {
    const storeNoA = a.store.storeNo;
    const storeNoB = b.store.storeNo;
    if (storeNoA === storeNoB) {
      const sessionStartTimeA = new Date(a.sessionStartTime).getTime();
      const sessionStartTimeB = new Date(b.sessionStartTime).getTime();
      if (sessionStartTimeA > sessionStartTimeB) {
        return -1;
      }
      return 1;
    }
    if (storeNoA > storeNoB) {
      return 1;
    }
    return -1;
  }
  if (schedulingDateA > schedulingDateB) {
    return 1;
  }
  return -1;
}

//去掉带域名的图片地址用来传给后台
// function initUrl(imgPaths) {
//   const regPath = /^(https|http):\/\/[^/]+\//;
//   const data = imgPaths.map((item) => {
//     if (regPath.test(item)) {
//       return item.replace(regPath, '');
//     }
//     return item;
//   });
//   return data;
// }

export default {
  namespace: 'activitySetting',
  state: {
    memberLevel: [],
    allStores: [], //存放所有的门店
    sessionCreatData: {
      id: null,
      schedulingDate: null,
      sessionStartTime: null,
      sessionEndTime: null,
      stores: [],
      totalNum: null,
      periodicFieldChecked: false,
      daysChecked: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      },
      periodicFieldEndDate: null,
      operationStatus: null,
    },
    sessionTableData: [], //场次表格数据
    baseData: {}, //基本设置
    sessionData: {}, //场次设置
    integralData: {}, //积分设置
    isEdit: null, //true說明點了編輯按鈕
    baseDataDefaultValues: null, //基本设置默认值
    sessionTableDataDefaultValues: null, //场次设置默认值
    integralDataDefaultValues: null, //积分设置默认值
    baseDate: null,
  },
  effects: {
    //会员等级
    *getMemberLevel({ payload: { values }, callback }, { call, put }) {
      const response = yield call(activitySetting.getMemberLevel, values);
      yield put({
        type: 'save',
        payload: {
          memberLevel: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *setSessionFormData({ payload }, { put, select }) {
      const sessionCreatData = yield select(
        (state) => state.activitySetting.sessionCreatData,
      );
      yield put({
        type: 'save',
        payload: { sessionCreatData: { ...sessionCreatData, ...payload } },
      });
    },
    *clearSessionFormData({ payload: {}, callback }, { put }) {
      yield put({
        type: 'save',
        payload: {
          isEdit: null,
          sessionCreatData: {
            id: null,
            schedulingDate: null,
            sessionStartTime: null,
            sessionEndTime: null,
            stores: [],
            totalNum: null,
            periodicFieldChecked: false,
            daysChecked: {
              monday: false,
              tuesday: false,
              wednesday: false,
              thursday: false,
              friday: false,
              saturday: false,
              sunday: false,
            },
            periodicFieldEndDate: null,
            operationStatus: null,
          },
        },
      });
      if (callback && typeof callback === 'function') {
        return callback();
      }
    },
    *getAllStores({}, { put, select }) {
      const storeTreeList = yield select((state) => state.common.storeTreeList); //门店数据
      //筛选出选中的对应的门店数据
      const stores = selectStoreTreeListFun(storeTreeList);
      yield put({
        type: 'save',
        payload: { allStores: stores },
      });
    },
    //新增数据
    *saveSessionTableData(
      {
        payload: {
          values: { index },
        },
        callback,
      },
      { put, select },
    ) {
      const { sessionCreatData, sessionTableData, allStores, isEdit } =
        yield select((state) => state.activitySetting);
      //newSessionCreatData过滤出stores的新变量
      const { stores, daysChecked, ...newSessionCreatData } = sessionCreatData;
      const { schedulingDate, periodicFieldEndDate, periodicFieldChecked } =
        newSessionCreatData;
      const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } =
        daysChecked;
      let weekDate = [];
      if (periodicFieldChecked && monday && typeof index !== 'number') {
        const mondayDates = getWeek(schedulingDate, periodicFieldEndDate, 1);
        weekDate = [...weekDate, ...mondayDates];
      }
      if (periodicFieldChecked && tuesday && typeof index !== 'number') {
        const tuesdayDates = getWeek(schedulingDate, periodicFieldEndDate, 2);
        weekDate = [...weekDate, ...tuesdayDates];
      }
      if (periodicFieldChecked && wednesday && typeof index !== 'number') {
        const wednesdayDates = getWeek(schedulingDate, periodicFieldEndDate, 3);
        weekDate = [...weekDate, ...wednesdayDates];
      }
      if (periodicFieldChecked && thursday && typeof index !== 'number') {
        const thursdayDates = getWeek(schedulingDate, periodicFieldEndDate, 4);
        weekDate = [...weekDate, ...thursdayDates];
      }
      if (periodicFieldChecked && friday && typeof index !== 'number') {
        const fridayDates = getWeek(schedulingDate, periodicFieldEndDate, 5);
        weekDate = [...weekDate, ...fridayDates];
      }
      if (periodicFieldChecked && saturday && typeof index !== 'number') {
        const saturdayDates = getWeek(schedulingDate, periodicFieldEndDate, 6);
        weekDate = [...weekDate, ...saturdayDates];
      }
      if (periodicFieldChecked && sunday && typeof index !== 'number') {
        const sundayDates = getWeek(schedulingDate, periodicFieldEndDate, 0);
        weekDate = [...weekDate, ...sundayDates];
      }
      let filterStores = allStores.filter((item) =>
        stores.includes(item.storeNo),
      );
      const newSessionTableData = filterStores.map((item) => ({
        ...newSessionCreatData,
        store: item,
        sessionStartTimeH: dayjs(newSessionCreatData.sessionStartTime).format(
          'HH:mm',
        ),
        sessionEndTimeH: dayjs(newSessionCreatData.sessionEndTime).format(
          'HH:mm',
        ),
        isShow: true,
      }));
      //data用于存放时间区间里循环生成的最后的场次数据
      let data = [];
      if (weekDate.length > 0) {
        newSessionTableData.forEach((item) => {
          for (let v of weekDate) {
            data.push({ ...item, schedulingDate: v.date, week: v });
          }
        });
      } else {
        data = newSessionTableData;
      }

      let sessionTableDataCollection = [...sessionTableData];
      if (isEdit) {
        sessionTableDataCollection.splice(index, 1, data[0]);
      } else {
        sessionTableDataCollection = [...sessionTableDataCollection, ...data];
      }
      //排序
      sessionTableDataCollection.sort(sortFun);
      //给数据添加一个下标属性
      const indexSessionTableDataCollection = sessionTableDataCollection.map(
        (item, i) => {
          return { ...item, rowIndex: i };
        },
      );
      yield put({
        type: 'save',
        payload: {
          sessionTableData: indexSessionTableDataCollection,
          isEdit: null,
        },
      });
      yield put({
        type: 'clearSessionFormData',
      });
      if (
        callback &&
        typeof callback === 'function' &&
        sessionTableData.length === sessionTableDataCollection.length
      ) {
        return callback();
      }
    },
    //編輯row
    *editData(
      {
        payload: {
          values: { sessionCreatEditData },
        },
      },
      { put },
    ) {
      yield put({
        type: 'save',
        payload: {
          sessionCreatData: sessionCreatEditData,
          isEdit: 'edit',
        },
      });
    },
    //复制场次数据
    *copyData(
      {
        payload: {
          values: { row, index },
        },
      },
      { put, select },
    ) {
      const { sessionTableData } = yield select(
        (state) => state.activitySetting,
      );
      const newSessionTableData = [...sessionTableData];
      newSessionTableData.splice(index, 0, {
        ...row,
        id: null,
        operationStatus: 'add',
      });
      //给数据添加一个下标属性
      const indexNewSessionTableData = newSessionTableData.map((item, i) => {
        return { ...item, rowIndex: i };
      });
      yield put({
        type: 'save',
        payload: {
          sessionTableData: indexNewSessionTableData,
          isEdit: null,
        },
      });
    },
    //删除场次数据
    *deleteSessionData(
      {
        payload: {
          values: { index },
        },
        callback,
      },
      { select, put },
    ) {
      const { sessionTableData } = yield select(
        (state) => state.activitySetting,
      );
      const newSessionTableData = [...sessionTableData];
      newSessionTableData[index].operationStatus = 'del';
      yield put({
        type: 'save',
        payload: {
          sessionTableData: newSessionTableData,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback();
      }
    },
    //保存表單
    *saveForm({ payload: { values }, callback }, { put }) {
      const { key, data, id } = values;
      yield put({
        type: 'save',
        payload: {
          [key]: data,
        },
      });
      if (key === 'integralData') {
        yield put({
          type: 'creatForm',
          payload: {
            id,
            callback,
          },
        });
      }
    },
    *creatForm({ payload: { id, callback } }, { select, call }) {
      const { baseData, sessionData, integralData, memberLevel } = yield select(
        (state) => state.activitySetting,
      );
      const { tableData } = sessionData;
      //基本设置
      const name = baseData.name; //标题
      const beginDateTime = `${baseData.date.startDate} 00:00:00`; //活动开始时间
      const endDateTime = `${baseData.date.endDate} 23:59:59`; //活动结束时间
      const advanceDate = Number(baseData.advanceDate); //提前几天开始预约
      const number = Number(baseData.number); //活动每人可以预约次数
      const dailyNumberLimit = Number(baseData.dailyNumberLimit); //每天每人可以预约次数
      const screeningNumberLimit = Number(baseData.screeningNumberLimit); //单场单人可预约次数
      const screeningNumber = Number(baseData.screeningNumber); //每人最多可参加场次次数
      let bookingInfoUrls = baseData.booking_info;
      let landingUrls = baseData.landing;
      let bannerImgUrls = baseData.bannerImg;
      const backgroundImg = {
        // 落地页底图 预约详情底图
        booking_info: bookingInfoUrls[0],
        landing: landingUrls[0],
      };
      const bannerImg = bannerImgUrls; //banner图
      const videoUrl = baseData.videoUrl; //视频
      const miniProgram = baseData.miniProgram;
      const description = baseData.description; //描述
      const instructions = baseData.instructions; //须知
      //场次设置
      //新增场次信息
      const addScheduling = tableData
        .filter((item) => item.operationStatus === 'add')
        .map((item) => {
          const schedulingDate = item.schedulingDate;
          const storeId = item.store.storeId;
          const storeName = item.store.name;
          const storeNo = item.store.storeNo;
          const totalNum = Number(item.totalNum);
          const beginTime = `${item.sessionStartTimeH}:00`;
          const endTime = `${item.sessionEndTimeH}:00`;
          return {
            schedulingDate,
            storeId,
            storeName,
            storeNo,
            totalNum,
            beginTime,
            endTime,
          };
        });
      //更新场次信息
      const updateScheduling = tableData
        .filter((item) => item.operationStatus === 'edit')
        .map((item) => {
          const schedulingId = item.id;
          const schedulingDate = item.schedulingDate;
          const storeId = item.store.storeId;
          const storeName = item.store.name;
          const storeNo = item.store.storeNo;
          const totalNum = Number(item.totalNum);
          const beginTime = `${item.sessionStartTimeH}:00`;
          const endTime = `${item.sessionEndTimeH}:00`;
          return {
            schedulingId,
            schedulingDate,
            storeId,
            storeName,
            storeNo,
            totalNum,
            beginTime,
            endTime,
          };
        });
      //删除场次信息
      const deleteScheduling = tableData
        .filter((item) => item.operationStatus === 'del' && item.id)
        .map((item) => {
          const schedulingId = item.id;
          const schedulingDate = item.schedulingDate;
          const storeId = item.store.storeId;
          const storeName = item.store.name;
          const storeNo = item.store.storeNo;
          const totalNum = Number(item.totalNum);
          const beginTime = `${item.sessionStartTimeH}:00`;
          const endTime = `${item.sessionEndTimeH}:00`;
          return {
            schedulingId,
            schedulingDate,
            storeId,
            storeName,
            storeNo,
            totalNum,
            beginTime,
            endTime,
          };
        });
      //积分设置
      const point = memberLevel.map((item, index) => {
        return {
          level: item.code,
          levelPoint:
            integralData['level' + index] || integralData['level' + index] === 0
              ? Number(integralData['level' + index])
              : null,
        };
      });
      const formParameter = {
        name,
        beginDateTime,
        endDateTime,
        advanceDate,
        number,
        dailyNumberLimit,
        screeningNumberLimit,
        screeningNumber,
        backgroundImg,
        bannerImg,
        description,
        instructions,
        addScheduling,
        point,
        miniProgram,
        videoUrl,
      };
      let response = null;
      if (id) {
        formParameter.id = id;
        formParameter.updateScheduling = updateScheduling;
        formParameter.deleteScheduling = deleteScheduling;

        try {
          response = yield call(
            activitySetting.updateActivityBooking,
            formParameter,
          );
        } catch (error) {
          return callback(error);
        }
      } else {
        response = yield call(
          activitySetting.addActivityBooking,
          formParameter,
        );
      }
      if (callback && typeof callback === 'function') {
        return callback(response, formParameter);
      }
    },
    //获取详情
    *getDetail({ payload: { values } }, { call, put }) {
      /*
       *基本设置的初始化数据baseDataDefaultValues
       */
      const response = yield call(activitySetting.getDetail, values);
      const data = response.data;
      const name = data.name;
      const startDate = data.beginDateTime.split(/[ ]+/)[0];
      const endDate = data.endDateTime.split(/[ ]+/)[0];
      const date = { startDate, endDate };
      const advanceDate = data.advanceDate;
      const number = data.number;
      const dailyNumberLimit = data.dailyNumberLimit;
      const screeningNumberLimit = data.screeningNumberLimit;
      const screeningNumber = data.screeningNumber;
      const landing = [data.backgroundImg.landing];
      const bookingInfo = [data.backgroundImg.booking_info];
      const bannerImg = data.bannerImg.length === 0 ? null : data.bannerImg;
      const description = data.description;
      const instructions = data.instructions;
      const videoUrl = data.videoUrl;
      const title = data?.miniProgram?.title;
      const pagePath = data?.miniProgram?.pagePath;
      const thumbUrl = data?.miniProgram?.thumbUrl
        ? [data?.miniProgram?.thumbUrl]
        : null;
      const baseData = {
        name,
        date,
        advanceDate,
        number,
        dailyNumberLimit,
        screeningNumberLimit,
        screeningNumber,
        landing,
        booking_info: bookingInfo,
        bannerImg,
        description,
        instructions,
        title,
        pagePath,
        thumbUrl,
        videoUrl,
      };

      /*
       *场次设置的初始化数据sessionTableDataDefaultValues
       */
      const scheduling = data.scheduling.map((item, index) => {
        const id = item.id;
        const isShow = true;
        const operationStatus = null;
        const schedulingDate = item.schedulingDate;
        const sessionEndTimeArray = item.endTime.split(':');
        const sessionStartTimeHArray = item.beginTime.split(':');
        const sessionEndTime = `${dayjs(new Date()).format('YYYY-MM-DD')} ${
          item.endTime
        }`;
        const sessionEndTimeH = `${sessionEndTimeArray[0]}:${sessionEndTimeArray[1]}`;
        const sessionStartTime = `${dayjs(new Date()).format('YYYY-MM-DD')} ${
          item.beginTime
        }`;
        const sessionStartTimeH = `${sessionStartTimeHArray[0]}:${sessionStartTimeHArray[1]}`;
        const store = {
          storeId: item.storeId,
          name: item.storeName,
          storeNo: item.storeNo,
        };
        const totalNum = item.totalNum;
        return {
          id,
          isShow,
          operationStatus,
          schedulingDate,
          sessionEndTime,
          sessionEndTimeH,
          sessionStartTime,
          sessionStartTimeH,
          store,
          totalNum,
          rowIndex: index,
        };
      });

      /*
       *积分设置的初始化数据integralDataDefaultValues
       */
      const integralData = {};
      data.point.map((item, index) => {
        integralData[`level${index}`] = item.levelPoint;
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          baseDataDefaultValues: baseData,
          sessionTableDataDefaultValues: scheduling,
          sessionTableData: scheduling,
          integralDataDefaultValues: integralData,
        },
      });
    },
    //把批量导入成功的数据添加到sessionCreatData里，用以渲染场次列表和保存
    *insertImportSessionCreatData({ payload: { values } }, { select, put }) {
      const { sessionTableData } = yield select(
        (state) => state.activitySetting,
      );
      const initValue = values.map((item) => {
        const id = item?.id;
        const operationStatus = 'add';
        const periodicFieldChecked = false;
        const periodicFieldEndDate = null;
        const schedulingDate = item?.schedulingDate;
        const sessionStartTime = `${dayjs(new Date()).format('YYYY-MM-DD')} ${
          item?.beginTime
        }`;
        const sessionEndTime = `${dayjs(new Date()).format('YYYY-MM-DD')} ${
          item?.endTime
        }`;
        const totalNum = item?.totalNum;
        const store = {
          name: item?.storeName,
          storeNo: item?.storeNo,
          storeId: item.storeId,
        };
        return {
          id,
          operationStatus,
          periodicFieldChecked,
          periodicFieldEndDate,
          schedulingDate,
          sessionStartTime,
          sessionEndTime,
          totalNum,
          store,
          sessionStartTimeH: dayjs(sessionStartTime).format('HH:mm'),
          sessionEndTimeH: dayjs(sessionEndTime).format('HH:mm'),
          isShow: true,
        };
      });
      const sessionTableDataCollection = [...sessionTableData, ...initValue];

      //排序
      sessionTableDataCollection.sort(sortFun);
      //给数据添加一个下标属性
      const indexSessionTableDataCollection = sessionTableDataCollection.map(
        (item, i) => {
          return { ...item, rowIndex: i };
        },
      );
      yield put({
        type: 'save',
        payload: {
          sessionTableData: indexSessionTableDataCollection,
          isEdit: null,
        },
      });
    },
    *createAndUpdateListCard({ payload: { values }, callback }, { call }) {
      const response = yield call(
        activitySetting.createAndUpdateListCard,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getCardListData({ payload: { values }, callback }, { call, put }) {
      const response = yield call(activitySetting.getCardList, values);
      const data = response?.data?.[0];
      data.thumbUrl = [data.thumbUrl];
      yield put({
        type: 'save',
        payload: {
          cardSettingData: data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *setBaseDate({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          baseDate: values.date,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/marketing/appoint_activity/activity_setting' ||
          props.pathname ===
            '/marketing/appoint_activity/activity_setting_edit' ||
          props.pathname ===
            '/marketing/appoint_activity/activity_setting_detail'
        ) {
          dispatch({
            type: 'save',
            payload: {
              memberLevel: [],
              allStores: [], //存放所有的门店
              sessionCreatData: {
                id: null,
                schedulingDate: null,
                sessionStartTime: null,
                sessionEndTime: null,
                stores: [],
                totalNum: null,
                periodicFieldChecked: false,
                daysChecked: {
                  monday: false,
                  tuesday: false,
                  wednesday: false,
                  thursday: false,
                  friday: false,
                  saturday: false,
                  sunday: false,
                },
                periodicFieldEndDate: null,
                operationStatus: null,
              },
              sessionTableData: [], //场次表格数据,
              baseData: {}, //基本设置
              sessionData: {}, //场次设置
              integralData: {}, //积分设置
              isEdit: null, //true說明點了編輯按鈕
              baseDataDefaultValues: null, //基本设置默认值
              sessionTableDataDefaultValues: null, //场次设置默认值
              integralDataDefaultValues: null, //积分设置默认值
              baseDate: null,
            },
          });
        }
      });
    },
  },
};
